module.exports = __webpack_public_path__ + "static/media/wizualizacja-107.e5758978.png";